<template>
  <div class="filters">
    <div class="container">
      <div class="filter-set">
        <div v-if="loading" class="loader"></div>
        <template v-else>
          <div class="filter filter_category">
            <ul>
              <li :class="{'selected': !filters.type}" @click.prevent="onTypeChange('')"><a>All</a></li>
              <li v-for="item in typeOptions" :key="item" :class="{'selected': filters.type === item}" @click.prevent="onTypeChange(item)"><a>{{ item }}</a></li>            
            </ul>
          </div>
          <div class="filter filter_searchable filter_clients">
            <select :value="filters.client" @change="onChange('client', $event)">
              <option value="" :selected="!filters.client" >All Clients</option>
              <option v-for="item in clientOptions" :key="item" :selected="filters.client === item">{{ item }}</option>
            </select>
          </div>
          <div class="filter filter_searchable filter_industry">
            <select :value="filters.industry" @change="onChange('industry', $event)">
              <option value="" :selected="!filters.industry">All Industries</option>
              <option v-for="item in industryOptions" :key="item" :selected="filters.industry === item">{{ item }}</option>            
            </select>
          </div>
          <div class="filter filter_year">
            <select :value="filters.year" @change="onChange('year', $event)">
              <option value="" :selected="!filters.year">All Years</option>
              <option v-for="item in yearOptions" :key="item" :selected="filters.year === item">{{ item }}</option>            
            </select>
          </div>
          <div class="filter reset">
            <button class="btn btn-hollow toggle-btn reset-filters" :disabled="filtersCount === 0" @click="resetFilters"><span>Reset</span></button>
          </div>
        </template>
      </div>        
    </div>
  </div>
</template>

<script>
import conceptsService from "@/services/conceptsService";
import utils from "@/utils/index";

const FILTERS_STORAGE_KEY = "clue.concepts.filters";
const DEFAULT_FILTERS = {
  type: "",
  client: "",
  industry: "",
  year: ""
};

export default {
  name: 'ConceptFilters',
  components: {},

  data() {
    return {
      filters: { ...DEFAULT_FILTERS },
      loading: false,
      typeOptions: [],
      industryOptions: [],
      clientOptions: [],
      yearOptions: []
    }
  },

  computed: {
    showFilters() {
      return this.$store.state.showFilters;
    },
    filtersCount() {
      return this.$store.getters["filtersCount"];
    }
  },

  methods: {
    getDefaultFilters() {
      return { ...DEFAULT_FILTERS };
    },
    loadSavedFilters() {
      const savedFilters = localStorage.getItem(FILTERS_STORAGE_KEY);
      if (!savedFilters) {
        return this.getDefaultFilters();
      }

      try {
        const parsedFilters = JSON.parse(savedFilters);

        return Object.keys(DEFAULT_FILTERS).reduce((filters, key) => {
          filters[key] = typeof parsedFilters[key] === "string" ? parsedFilters[key] : "";
          return filters;
        }, this.getDefaultFilters());
      } catch {
        localStorage.removeItem(FILTERS_STORAGE_KEY);
        return this.getDefaultFilters();
      }
    },
    saveFilters() {
      localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(this.filters));
    },
    applyFilters() {
      this.saveFilters();
      this.$store.dispatch("changeFilters", { ...this.filters });
    },
    async bindFilters() {
      let [clients, industries, types, years] = await Promise.all([conceptsService.getClientsFilter(), conceptsService.getIndustriesFilter(),conceptsService.getTypesFilter(),conceptsService.getYearsFilter()]);
      this.clientOptions = utils.distinct(clients.filter(c => c.title?.length > 0).map(c => c.title));
      this.industryOptions = utils.distinct(industries.filter(item => item?.length > 0));
      this.typeOptions = utils.distinct(types.filter(item => item?.length > 0));
      this.yearOptions = years.filter(item => item?.length > 0);
    },
    resetFilters() {
      try {
        $('.filter_searchable.filter_clients select')[0].sumo.selectItem(0);
        $('.filter_searchable.filter_industry select')[0].sumo.selectItem(0);
        $('.filter_year select')[0].sumo.selectItem(0);
      } catch {}

      this.filters = this.getDefaultFilters();
      localStorage.removeItem(FILTERS_STORAGE_KEY);
      this.$store.dispatch("changeFilters", { ...this.filters });
    },
    onChange(key, e) {
      console.log("onChange", e.target.value);
      this.filters[key] = e.target.value;
      this.applyFilters();
    },
    onTypeChange(type) {
      this.filters.type = type;
      this.applyFilters();
    },    
  },

  watch: {
    showFilters() {
      $('.filters').toggleClass('show');
    }
  },

  created() {
    this.filters = this.loadSavedFilters();
    this.$store.dispatch("changeFilters", { ...this.filters });
  },

  async mounted() {
    this.loading = true;
    await this.bindFilters();
    this.loading = false;
    this.$nextTick(() => {
      $('.filter_year select').SumoSelect();
      $('.filter_searchable select').SumoSelect({search: true, searchText: ''});  
    });
  }
}
</script>
